module.exports = __webpack_public_path__ + "media/images/MBI-221a3c0812c4f9b2a58fc6b55843a789.png";